import React from 'react';
import Input from '../../containers/Input/Input';

const InputSelect = ({ options, ...props }) => {
  return (
    <Input {...props} inputType="select">
      {options.map(({ value, label }) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </Input>
  );
};

export default InputSelect;
